/**
 * Provides button globals settings
 */
import { Colors } from '@nakedplatform/ui';
import { FontWeight } from 'theme/fonts';

/**
 * Used as a variant for different button types
 */
export const BUTTON_TYPES = {
  primary: {
    color: Colors.white,
    background: `linear-gradient(225deg, ${Colors.jade}, ${Colors.emerald})`,
    boxShadow: '0px 7px 20px 0 rgba(0, 141, 60, 0.25)',
    '&:hover': {
      background: Colors.jade,
    },
    '&:active': {
      background: Colors.salem,
      boxShadow: 'unset',
    },
  },
  secondary: {
    color: Colors.white,
    background: Colors.thunder,
    '&:hover': {
      background: Colors.black,
    },
    '&:active': {
      background: Colors.thunder,
    },
  },
  tertiary: {
    color: Colors.thunder,
    background: Colors.gallery,
    '&:hover': {
      background: Colors.emerald,
      color: Colors.white,
    },
    '&:active': {
      background: Colors.salem,
      color: Colors.white,
    },
  },
};

/**
 * Used a variant for different button sizes
 */
export const BUTTON_SIZES = {
  small: {
    height: 35,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 35,
    paddingRight: 35,
    borderRadius: 17.5,
    fontSize: 14,
    letterSpacing: 0.7,
    lineHeight: 2.5,
    fontWeight: FontWeight.medium,
  },
  medium: {
    height: 45,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 35,
    paddingRight: 35,
    borderRadius: 25,
    fontSize: 15,
    letterSpacing: 0.6,
    lineHeight: '45px',
    fontWeight: FontWeight.regular,
  },
  large: {
    height: 60,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 35,
    paddingRight: 35,
    borderRadius: 60,
    fontSize: 18,
    letterSpacing: 0.6,
    lineHeight: '45px',
    fontWeight: FontWeight.medium,
  },
};
